export default "__VITE_PUBLIC_ASSET__3db50edb__"